/**
 * CCSS ELA Standards — Common Core State Standards for English Language Arts
 * Writing (W) and Language (L) standards for grades 7-12
 * Public domain text from corestandards.org
 *
 * Structure: CCSS_ELA_BY_GRADE[gradeBand][standardCode] = { title, subs }
 * Flat exports (CCSS_ELA_STANDARDS, CCSS_STANDARDS) maintained for backwards compat.
 */

export const CCSS_ELA_BY_GRADE = {
  // ═══════════════════════════════════════════════
  // GRADE 7
  // ═══════════════════════════════════════════════
  "7": {
    // ── Writing ──
    "W.7.1": {
      title: "Write arguments to support claims with clear reasons and relevant evidence.",
      subs: {
        "W.7.1a": "Introduce claim(s), acknowledge alternate or opposing claims, and organize the reasons and evidence logically.",
        "W.7.1b": "Support claim(s) with logical reasoning and relevant evidence, using accurate, credible sources and demonstrating an understanding of the topic or text.",
        "W.7.1c": "Use words, phrases, and clauses to create cohesion and clarify the relationships among claim(s), reasons, and evidence.",
        "W.7.1d": "Establish and maintain a formal style.",
        "W.7.1e": "Provide a concluding statement or section that follows from and supports the argument presented."
      }
    },
    "W.7.2": {
      title: "Write informative/explanatory texts to examine a topic and convey ideas, concepts, and information through the selection, organization, and analysis of relevant content.",
      subs: {
        "W.7.2a": "Introduce a topic clearly, previewing what is to follow; organize ideas, concepts, and information, using strategies such as definition, classification, comparison/contrast, and cause/effect; include formatting (e.g., headings), graphics (e.g., charts, tables), and multimedia when useful to aiding comprehension.",
        "W.7.2b": "Develop the topic with relevant facts, definitions, concrete details, quotations, or other information and examples.",
        "W.7.2c": "Use appropriate transitions to create cohesion and clarify the relationships among ideas and concepts.",
        "W.7.2d": "Use precise language and domain-specific vocabulary to inform about or explain the topic.",
        "W.7.2e": "Establish and maintain a formal style.",
        "W.7.2f": "Provide a concluding statement or section that follows from and supports the information or explanation presented."
      }
    },
    "W.7.3": {
      title: "Write narratives to develop real or imagined experiences or events using effective technique, relevant descriptive details, and well-structured event sequences.",
      subs: {
        "W.7.3a": "Engage and orient the reader by establishing a context and point of view and introducing a narrator and/or characters; organize an event sequence that unfolds naturally and logically.",
        "W.7.3b": "Use narrative techniques, such as dialogue, pacing, and description, to develop experiences, events, and/or characters.",
        "W.7.3c": "Use a variety of transition words, phrases, and clauses to convey sequence and signal shifts from one time frame or setting to another.",
        "W.7.3d": "Use precise words and phrases, relevant descriptive details, and sensory language to capture the action and convey experiences and events.",
        "W.7.3e": "Provide a conclusion that follows from and reflects on the narrated experiences or events."
      }
    },
    "W.7.4": {
      title: "Produce clear and coherent writing in which the development, organization, and style are appropriate to task, purpose, and audience.",
      subs: {}
    },
    "W.7.5": {
      title: "With some guidance and support from peers and adults, develop and strengthen writing as needed by planning, revising, editing, rewriting, or trying a new approach, focusing on how well purpose and audience have been addressed.",
      subs: {}
    },
    "W.7.6": {
      title: "Use technology, including the Internet, to produce and publish writing and link to and cite sources as well as to interact and collaborate with others, including linking to and citing sources.",
      subs: {}
    },
    "W.7.7": {
      title: "Conduct short research projects to answer a question, drawing on several sources and generating additional related, focused questions for further research and investigation.",
      subs: {}
    },
    "W.7.8": {
      title: "Gather relevant information from multiple print and digital sources, using search terms effectively; assess the credibility and accuracy of each source; and quote or paraphrase the data and conclusions of others while avoiding plagiarism and following a standard format for citation.",
      subs: {}
    },
    "W.7.9": {
      title: "Draw evidence from literary or informational texts to support analysis, reflection, and research.",
      subs: {
        "W.7.9a": "Apply grade 7 Reading standards to literature (e.g., \u201cCompare and contrast a fictional portrayal of a time, place, or character and a historical account of the same period as a means of understanding how authors of fiction use or alter history\u201d).",
        "W.7.9b": "Apply grade 7 Reading standards to literary nonfiction (e.g., \u201cTrace and evaluate the argument and specific claims in a text, assessing whether the reasoning is sound and the evidence is relevant and sufficient to support the claims\u201d)."
      }
    },
    "W.7.10": {
      title: "Write routinely over extended time frames (time for research, reflection, and revision) and shorter time frames (a single sitting or a day or two) for a range of discipline-specific tasks, purposes, and audiences.",
      subs: {}
    },
    // ── Language ──
    "L.7.1": {
      title: "Demonstrate command of the conventions of standard English grammar and usage when writing or speaking.",
      subs: {
        "L.7.1a": "Explain the function of phrases and clauses in general and their function in specific sentences.",
        "L.7.1b": "Choose among simple, compound, complex, and compound-complex sentences to signal differing relationships among ideas.",
        "L.7.1c": "Place phrases and clauses within a sentence, recognizing and correcting misplaced and dangling modifiers."
      }
    },
    "L.7.2": {
      title: "Demonstrate command of the conventions of standard English capitalization, punctuation, and spelling when writing.",
      subs: {
        "L.7.2a": "Use a comma to separate coordinate adjectives (e.g., It was a fascinating, enjoyable movie but not He wore an old[,] green shirt).",
        "L.7.2b": "Spell correctly."
      }
    },
    "L.7.3": {
      title: "Use knowledge of language and its conventions when writing, speaking, reading, or listening.",
      subs: {
        "L.7.3a": "Choose language that expresses ideas precisely and concisely, recognizing and eliminating wordiness and redundancy."
      }
    },
    "L.7.4": {
      title: "Determine or clarify the meaning of unknown and multiple-meaning words and phrases based on grade 7 reading and content, choosing flexibly from a range of strategies.",
      subs: {
        "L.7.4a": "Use context (e.g., the overall meaning of a sentence or paragraph; a word\u2019s position or function in a sentence) as a clue to the meaning of a word or phrase.",
        "L.7.4b": "Use common, grade-appropriate Greek or Latin affixes and roots as clues to the meaning of a word (e.g., belligerent, bellicose, rebel).",
        "L.7.4c": "Consult general and specialized reference materials (e.g., dictionaries, glossaries, thesauruses), both print and digital, to find the pronunciation of a word or determine or clarify its precise meaning or its part of speech.",
        "L.7.4d": "Verify the preliminary determination of the meaning of a word or phrase (e.g., by checking the inferred meaning in context or in a dictionary)."
      }
    },
    "L.7.5": {
      title: "Demonstrate understanding of figurative language, word relationships, and nuances in word meanings.",
      subs: {
        "L.7.5a": "Interpret figures of speech (e.g., literary, biblical, and mythological allusions) in context.",
        "L.7.5b": "Use the relationship between particular words (e.g., synonym/antonym, analogy) to better understand each of the words.",
        "L.7.5c": "Distinguish among the connotations (associations) of words with similar denotations (definitions) (e.g., refined, respectful, polite, diplomatic, condescending)."
      }
    },
    "L.7.6": {
      title: "Acquire and use accurately grade-appropriate general academic and domain-specific words and phrases; gather vocabulary knowledge when considering a word or phrase important to comprehension or expression.",
      subs: {}
    },
  },

  // ═══════════════════════════════════════════════
  // GRADE 8
  // ═══════════════════════════════════════════════
  "8": {
    // ── Writing ──
    "W.8.1": {
      title: "Write arguments to support claims with clear reasons and relevant evidence.",
      subs: {
        "W.8.1a": "Introduce claim(s), acknowledge and distinguish the claim(s) from alternate or opposing claims, and organize the reasons and evidence logically.",
        "W.8.1b": "Support claim(s) with logical reasoning and relevant evidence, using accurate, credible sources and demonstrating an understanding of the topic or text.",
        "W.8.1c": "Use words, phrases, and clauses to create cohesion and clarify the relationships among claim(s), counterclaims, reasons, and evidence.",
        "W.8.1d": "Establish and maintain a formal style.",
        "W.8.1e": "Provide a concluding statement or section that follows from and supports the argument presented."
      }
    },
    "W.8.2": {
      title: "Write informative/explanatory texts to examine a topic and convey ideas, concepts, and information through the selection, organization, and analysis of relevant content.",
      subs: {
        "W.8.2a": "Introduce a topic clearly, previewing what is to follow; organize ideas, concepts, and information into broader categories; include formatting (e.g., headings), graphics (e.g., charts, tables), and multimedia when useful to aiding comprehension.",
        "W.8.2b": "Develop the topic with relevant, well-chosen facts, definitions, concrete details, quotations, or other information and examples.",
        "W.8.2c": "Use appropriate and varied transitions to create cohesion and clarify the relationships among ideas and concepts.",
        "W.8.2d": "Use precise language and domain-specific vocabulary to inform about or explain the topic.",
        "W.8.2e": "Establish and maintain a formal style.",
        "W.8.2f": "Provide a concluding statement or section that follows from and supports the information or explanation presented."
      }
    },
    "W.8.3": {
      title: "Write narratives to develop real or imagined experiences or events using effective technique, relevant descriptive details, and well-structured event sequences.",
      subs: {
        "W.8.3a": "Engage and orient the reader by establishing a context and point of view and introducing a narrator and/or characters; organize an event sequence that unfolds naturally and logically.",
        "W.8.3b": "Use narrative techniques, such as dialogue, pacing, description, and reflection, to develop experiences, events, and/or characters.",
        "W.8.3c": "Use a variety of transition words, phrases, and clauses to convey sequence, signal shifts from one time frame or setting to another, and show the relationships among experiences and events.",
        "W.8.3d": "Use precise words and phrases, relevant descriptive details, and sensory language to capture the action and convey experiences and events.",
        "W.8.3e": "Provide a conclusion that follows from and reflects on the narrated experiences or events."
      }
    },
    "W.8.4": {
      title: "Produce clear and coherent writing in which the development, organization, and style are appropriate to task, purpose, and audience.",
      subs: {}
    },
    "W.8.5": {
      title: "With some guidance and support from peers and adults, develop and strengthen writing as needed by planning, revising, editing, rewriting, or trying a new approach, focusing on how well purpose and audience have been addressed.",
      subs: {}
    },
    "W.8.6": {
      title: "Use technology, including the Internet, to produce and publish writing and present the relationships between information and ideas efficiently as well as to interact and collaborate with others.",
      subs: {}
    },
    "W.8.7": {
      title: "Conduct short research projects to answer a question (including a self-generated question), drawing on several sources and generating additional related, focused questions that allow for multiple avenues of exploration.",
      subs: {}
    },
    "W.8.8": {
      title: "Gather relevant information from multiple print and digital sources, using search terms effectively; assess the credibility and accuracy of each source; and quote or paraphrase the data and conclusions of others while avoiding plagiarism and following a standard format for citation.",
      subs: {}
    },
    "W.8.9": {
      title: "Draw evidence from literary or informational texts to support analysis, reflection, and research.",
      subs: {
        "W.8.9a": "Apply grade 8 Reading standards to literature (e.g., \u201cAnalyze how a modern work of fiction draws on themes, patterns of events, or character types from myths, traditional stories, or religious works such as the Bible, including describing how the material is rendered new\u201d).",
        "W.8.9b": "Apply grade 8 Reading standards to literary nonfiction (e.g., \u201cDelineate and evaluate the argument and specific claims in a text, assessing whether the reasoning is sound and the evidence is relevant and sufficient; recognize when irrelevant evidence is introduced\u201d)."
      }
    },
    "W.8.10": {
      title: "Write routinely over extended time frames (time for research, reflection, and revision) and shorter time frames (a single sitting or a day or two) for a range of discipline-specific tasks, purposes, and audiences.",
      subs: {}
    },
    // ── Language ──
    "L.8.1": {
      title: "Demonstrate command of the conventions of standard English grammar and usage when writing or speaking.",
      subs: {
        "L.8.1a": "Explain the function of verbals (gerunds, participles, infinitives) in general and their function in particular sentences.",
        "L.8.1b": "Form and use verbs in the active and passive voice.",
        "L.8.1c": "Form and use verbs in the indicative, imperative, interrogative, conditional, and subjunctive mood.",
        "L.8.1d": "Recognize and correct inappropriate shifts in verb voice and mood."
      }
    },
    "L.8.2": {
      title: "Demonstrate command of the conventions of standard English capitalization, punctuation, and spelling when writing.",
      subs: {
        "L.8.2a": "Use punctuation (comma, ellipsis, dash) to indicate a pause or break.",
        "L.8.2b": "Use an ellipsis to indicate an omission.",
        "L.8.2c": "Spell correctly."
      }
    },
    "L.8.3": {
      title: "Use knowledge of language and its conventions when writing, speaking, reading, or listening.",
      subs: {
        "L.8.3a": "Use verbs in the active and passive voice and in the conditional and subjunctive mood to achieve particular effects (e.g., emphasizing the actor or the action; expressing uncertainty or describing a state contrary to fact)."
      }
    },
    "L.8.4": {
      title: "Determine or clarify the meaning of unknown and multiple-meaning words or phrases based on grade 8 reading and content, choosing flexibly from a range of strategies.",
      subs: {
        "L.8.4a": "Use context (e.g., the overall meaning of a sentence or paragraph; a word\u2019s position or function in a sentence) as a clue to the meaning of a word or phrase.",
        "L.8.4b": "Use common, grade-appropriate Greek or Latin affixes and roots as clues to the meaning of a word (e.g., precede, recede, secede).",
        "L.8.4c": "Consult general and specialized reference materials (e.g., dictionaries, glossaries, thesauruses), both print and digital, to find the pronunciation of a word or determine or clarify its precise meaning or its part of speech.",
        "L.8.4d": "Verify the preliminary determination of the meaning of a word or phrase (e.g., by checking the inferred meaning in context or in a dictionary)."
      }
    },
    "L.8.5": {
      title: "Demonstrate understanding of figurative language, word relationships, and nuances in word meanings.",
      subs: {
        "L.8.5a": "Interpret figures of speech (e.g., verbal irony, puns) in context.",
        "L.8.5b": "Use the relationship between particular words to better understand each of the words.",
        "L.8.5c": "Distinguish among the connotations (associations) of words with similar denotations (definitions) (e.g., bullheaded, willful, firm, persistent, resolute)."
      }
    },
    "L.8.6": {
      title: "Acquire and use accurately grade-appropriate general academic and domain-specific words and phrases; gather vocabulary knowledge when considering a word or phrase important to comprehension or expression.",
      subs: {}
    },
  },

  // ═══════════════════════════════════════════════
  // GRADES 9-10
  // ═══════════════════════════════════════════════
  "9-10": {
    // ── Writing ──
    "W.9-10.1": {
      title: "Write arguments to support claims in an analysis of substantive topics or texts, using valid reasoning and relevant and sufficient evidence.",
      subs: {
        "W.9-10.1a": "Introduce precise, knowledgeable claim(s), establish the significance of the claim(s), distinguish the claim(s) from alternate or opposing claims, and create an organization that logically sequences claim(s), counterclaims, reasons, and evidence.",
        "W.9-10.1b": "Develop claim(s) and counterclaims fairly and thoroughly, supplying the most relevant evidence for each while pointing out the strengths and limitations of both in a manner that anticipates the audience\u2019s knowledge level, concerns, values, and possible biases.",
        "W.9-10.1c": "Use words, phrases, and clauses as well as varied syntax to link the major sections of the text, create cohesion, and clarify the relationships between claim(s) and reasons, between reasons and evidence, and between claim(s) and counterclaims.",
        "W.9-10.1d": "Establish and maintain a formal style and objective tone while attending to the norms and conventions of the discipline in which they are writing.",
        "W.9-10.1e": "Provide a concluding statement or section that follows from and supports the argument presented."
      }
    },
    "W.9-10.2": {
      title: "Write informative/explanatory texts to examine and convey complex ideas, concepts, and information clearly and accurately through the effective selection, organization, and analysis of content.",
      subs: {
        "W.9-10.2a": "Introduce a topic; organize complex ideas, concepts, and information to make important connections and distinctions; include formatting (e.g., headings), graphics (e.g., figures, tables), and multimedia when useful to aiding comprehension.",
        "W.9-10.2b": "Develop the topic with well-chosen, relevant, and sufficient facts, extended definitions, concrete details, quotations, or other information and examples appropriate to the audience\u2019s knowledge of the topic.",
        "W.9-10.2c": "Use appropriate and varied transitions to link the major sections of the text, create cohesion, and clarify the relationships among complex ideas and concepts.",
        "W.9-10.2d": "Use precise language and domain-specific vocabulary to manage the complexity of the topic.",
        "W.9-10.2e": "Establish and maintain a formal style and objective tone while attending to the norms and conventions of the discipline in which they are writing.",
        "W.9-10.2f": "Provide a concluding statement or section that follows from and supports the information or explanation presented (e.g., articulating implications or the significance of the topic)."
      }
    },
    "W.9-10.3": {
      title: "Write narratives to develop real or imagined experiences or events using effective technique, well-chosen details, and well-structured event sequences.",
      subs: {
        "W.9-10.3a": "Engage and orient the reader by setting out a problem, situation, or observation, establishing one or multiple point(s) of view, and introducing a narrator and/or characters; create a smooth progression of experiences or events.",
        "W.9-10.3b": "Use narrative techniques, such as dialogue, pacing, description, reflection, and multiple plot lines, to develop experiences, events, and/or characters.",
        "W.9-10.3c": "Use a variety of techniques to sequence events so that they build on one another to create a coherent whole.",
        "W.9-10.3d": "Use precise words and phrases, telling details, and sensory language to convey a vivid picture of the experiences, events, setting, and/or characters.",
        "W.9-10.3e": "Provide a conclusion that follows from and reflects on what is experienced, observed, or resolved over the course of the narrative."
      }
    },
    "W.9-10.4": {
      title: "Produce clear and coherent writing in which the development, organization, and style are appropriate to task, purpose, and audience.",
      subs: {}
    },
    "W.9-10.5": {
      title: "Develop and strengthen writing as needed by planning, revising, editing, rewriting, or trying a new approach, focusing on addressing what is most significant for a specific purpose and audience.",
      subs: {}
    },
    "W.9-10.6": {
      title: "Use technology, including the Internet, to produce, publish, and update individual or shared writing products, taking advantage of technology\u2019s capacity to link to other information and to display information flexibly and dynamically.",
      subs: {}
    },
    "W.9-10.7": {
      title: "Conduct short as well as more sustained research projects to answer a question (including a self-generated question) or solve a problem; narrow or broaden the inquiry when appropriate; synthesize multiple sources on the subject, demonstrating understanding of the subject under investigation.",
      subs: {}
    },
    "W.9-10.8": {
      title: "Gather relevant information from multiple authoritative print and digital sources, using advanced searches effectively; assess the usefulness of each source in answering the research question; integrate information into the text selectively to maintain the flow of ideas, avoiding plagiarism and following a standard format for citation.",
      subs: {}
    },
    "W.9-10.9": {
      title: "Draw evidence from literary or informational texts to support analysis, reflection, and research.",
      subs: {
        "W.9-10.9a": "Apply grades 9\u201310 Reading standards to literature (e.g., \u201cAnalyze how an author draws on and transforms source material in a specific work [e.g., how Shakespeare treats a theme or topic from Ovid or the Bible or how a later author draws on a play by Shakespeare]\u201d).",
        "W.9-10.9b": "Apply grades 9\u201310 Reading standards to literary nonfiction (e.g., \u201cDelineate and evaluate the argument and specific claims in a text, assessing whether the reasoning is valid and the evidence is relevant and sufficient; identify false statements and fallacious reasoning\u201d)."
      }
    },
    "W.9-10.10": {
      title: "Write routinely over extended time frames (time for research, reflection, and revision) and shorter time frames (a single sitting or a day or two) for a range of tasks, purposes, and audiences.",
      subs: {}
    },
    // ── Language ──
    "L.9-10.1": {
      title: "Demonstrate command of the conventions of standard English grammar and usage when writing or speaking.",
      subs: {
        "L.9-10.1a": "Use parallel structure.",
        "L.9-10.1b": "Use various types of phrases (noun, verb, adjectival, adverbial, participial, prepositional, absolute) and clauses (independent, dependent; noun, relative, adverbial) to convey specific meanings and add variety and interest to writing or presentations."
      }
    },
    "L.9-10.2": {
      title: "Demonstrate command of the conventions of standard English capitalization, punctuation, and spelling when writing.",
      subs: {
        "L.9-10.2a": "Use a semicolon (and perhaps a conjunctive adverb) to link two or more closely related independent clauses.",
        "L.9-10.2b": "Use a colon to introduce a list or quotation.",
        "L.9-10.2c": "Spell correctly."
      }
    },
    "L.9-10.3": {
      title: "Apply knowledge of language to understand how language functions in different contexts, to make effective choices for meaning or style, and to comprehend more fully when reading or listening.",
      subs: {
        "L.9-10.3a": "Write and edit work so that it conforms to the guidelines in a style manual (e.g., MLA Handbook, Turabian\u2019s Manual for Writers) appropriate for the discipline and writing type."
      }
    },
    "L.9-10.4": {
      title: "Determine or clarify the meaning of unknown and multiple-meaning words and phrases based on grades 9\u201310 reading and content, choosing flexibly from a range of strategies.",
      subs: {
        "L.9-10.4a": "Use context (e.g., the overall meaning of a sentence, paragraph, or text; a word\u2019s position or function in a sentence) as a clue to the meaning of a word or phrase.",
        "L.9-10.4b": "Identify and correctly use patterns of word changes that indicate different meanings or parts of speech (e.g., analyze, analysis, analytical; advocate, advocacy).",
        "L.9-10.4c": "Consult general and specialized reference materials (e.g., dictionaries, glossaries, thesauruses), both print and digital, to find the pronunciation of a word or determine or clarify its precise meaning, its part of speech, or its etymology.",
        "L.9-10.4d": "Verify the preliminary determination of the meaning of a word or phrase (e.g., by checking the inferred meaning in context or in a dictionary)."
      }
    },
    "L.9-10.5": {
      title: "Demonstrate understanding of figurative language, word relationships, and nuances in word meanings.",
      subs: {
        "L.9-10.5a": "Interpret figures of speech (e.g., euphemism, oxymoron) in context and analyze their role in the text.",
        "L.9-10.5b": "Analyze nuances in the meaning of words with similar denotations."
      }
    },
    "L.9-10.6": {
      title: "Acquire and use accurately general academic and domain-specific words and phrases, sufficient for reading, writing, speaking, and listening at the college and career readiness level; demonstrate independence in gathering vocabulary knowledge when considering a word or phrase important to comprehension or expression.",
      subs: {}
    },
  },

  // ═══════════════════════════════════════════════
  // GRADES 11-12
  // ═══════════════════════════════════════════════
  "11-12": {
    // ── Writing ──
    "W.11-12.1": {
      title: "Write arguments to support claims in an analysis of substantive topics or texts, using valid reasoning and relevant and sufficient evidence.",
      subs: {
        "W.11-12.1a": "Introduce precise, knowledgeable claim(s), establish the significance of the claim(s), distinguish the claim(s) from alternate or opposing claims, and create an organization that logically sequences claim(s), counterclaims, reasons, and evidence.",
        "W.11-12.1b": "Develop claim(s) and counterclaims fairly and thoroughly, supplying the most relevant evidence for each while pointing out the strengths and limitations of both in a manner that anticipates the audience\u2019s knowledge level, concerns, values, and possible biases.",
        "W.11-12.1c": "Use words, phrases, and clauses as well as varied syntax to link the major sections of the text, create cohesion, and clarify the relationships between claim(s) and reasons, between reasons and evidence, and between claim(s) and counterclaims.",
        "W.11-12.1d": "Establish and maintain a formal style and objective tone while attending to the norms and conventions of the discipline in which they are writing.",
        "W.11-12.1e": "Provide a concluding statement or section that follows from and supports the argument presented."
      }
    },
    "W.11-12.2": {
      title: "Write informative/explanatory texts to examine and convey complex ideas, concepts, and information clearly and accurately through the effective selection, organization, and analysis of content.",
      subs: {
        "W.11-12.2a": "Introduce a topic; organize complex ideas, concepts, and information so that each new element builds on that which precedes it to create a unified whole; include formatting (e.g., headings), graphics (e.g., figures, tables), and multimedia when useful to aiding comprehension.",
        "W.11-12.2b": "Develop the topic thoroughly by selecting the most significant and relevant facts, extended definitions, concrete details, quotations, or other information and examples appropriate to the audience\u2019s knowledge of the topic.",
        "W.11-12.2c": "Use appropriate and varied transitions and syntax to link the major sections of the text, create cohesion, and clarify the relationships among complex ideas and concepts.",
        "W.11-12.2d": "Use precise language, domain-specific vocabulary, and techniques such as metaphor, simile, and analogy to manage the complexity of the topic.",
        "W.11-12.2e": "Establish and maintain a formal style and objective tone while attending to the norms and conventions of the discipline in which they are writing.",
        "W.11-12.2f": "Provide a concluding statement or section that follows from and supports the information or explanation presented (e.g., articulating implications or the significance of the topic)."
      }
    },
    "W.11-12.3": {
      title: "Write narratives to develop real or imagined experiences or events using effective technique, well-chosen details, and well-structured event sequences.",
      subs: {
        "W.11-12.3a": "Engage and orient the reader by setting out a problem, situation, or observation and its significance, establishing one or multiple point(s) of view, and introducing a narrator and/or characters; create a smooth progression of experiences or events.",
        "W.11-12.3b": "Use narrative techniques, such as dialogue, pacing, description, reflection, and multiple plot lines, to develop experiences, events, and/or characters.",
        "W.11-12.3c": "Use a variety of techniques to sequence events so that they build on one another to create a coherent whole and build toward a particular tone and outcome (e.g., a sense of mystery, suspense, growth, or resolution).",
        "W.11-12.3d": "Use precise words and phrases, telling details, and sensory language to convey a vivid picture of the experiences, events, setting, and/or characters.",
        "W.11-12.3e": "Provide a conclusion that follows from and reflects on what is experienced, observed, or resolved over the course of the narrative."
      }
    },
    "W.11-12.4": {
      title: "Produce clear and coherent writing in which the development, organization, and style are appropriate to task, purpose, and audience.",
      subs: {}
    },
    "W.11-12.5": {
      title: "Develop and strengthen writing as needed by planning, revising, editing, rewriting, or trying a new approach, focusing on addressing what is most significant for a specific purpose and audience.",
      subs: {}
    },
    "W.11-12.6": {
      title: "Use technology, including the Internet, to produce, publish, and update individual or shared writing products in response to ongoing feedback, including new arguments or information.",
      subs: {}
    },
    "W.11-12.7": {
      title: "Conduct short as well as more sustained research projects to answer a question (including a self-generated question) or solve a problem; narrow or broaden the inquiry when appropriate; synthesize multiple sources on the subject, demonstrating understanding of the subject under investigation.",
      subs: {}
    },
    "W.11-12.8": {
      title: "Gather relevant information from multiple authoritative print and digital sources, using advanced searches effectively; assess the strengths and limitations of each source in terms of the task, purpose, and audience; integrate information into the text selectively to maintain the flow of ideas, avoiding plagiarism and overreliance on any one source and following a standard format for citation.",
      subs: {}
    },
    "W.11-12.9": {
      title: "Draw evidence from literary or informational texts to support analysis, reflection, and research.",
      subs: {
        "W.11-12.9a": "Apply grades 11\u201312 Reading standards to literature (e.g., \u201cDemonstrate knowledge of eighteenth-, nineteenth- and early-twentieth-century foundational works of American literature, including how two or more texts from the same period treat similar themes or topics\u201d).",
        "W.11-12.9b": "Apply grades 11\u201312 Reading standards to literary nonfiction (e.g., \u201cDelineate and evaluate the reasoning in seminal U.S. texts, including the application of constitutional principles and use of legal reasoning [e.g., in U.S. Supreme Court majority opinions and dissents] and the premises, purposes, and arguments in works of public advocacy [e.g., The Federalist, presidential addresses]\u201d)."
      }
    },
    "W.11-12.10": {
      title: "Write routinely over extended time frames (time for research, reflection, and revision) and shorter time frames (a single sitting or a day or two) for a range of tasks, purposes, and audiences.",
      subs: {}
    },
    // ── Language ──
    "L.11-12.1": {
      title: "Demonstrate command of the conventions of standard English grammar and usage when writing or speaking.",
      subs: {
        "L.11-12.1a": "Apply the understanding that usage is a matter of convention, can change over time, and is sometimes contested.",
        "L.11-12.1b": "Resolve issues of complex or contested usage, consulting references (e.g., Merriam-Webster\u2019s Dictionary of English Usage, Garner\u2019s Modern American Usage) as needed."
      }
    },
    "L.11-12.2": {
      title: "Demonstrate command of the conventions of standard English capitalization, punctuation, and spelling when writing.",
      subs: {
        "L.11-12.2a": "Observe hyphenation conventions.",
        "L.11-12.2b": "Spell correctly."
      }
    },
    "L.11-12.3": {
      title: "Apply knowledge of language to understand how language functions in different contexts, to make effective choices for meaning or style, and to comprehend more fully when reading or listening.",
      subs: {
        "L.11-12.3a": "Vary syntax for effect, consulting references (e.g., Tufte\u2019s Artful Sentences) for guidance as needed; apply an understanding of syntax to the study of complex texts when reading."
      }
    },
    "L.11-12.4": {
      title: "Determine or clarify the meaning of unknown and multiple-meaning words and phrases based on grades 11\u201312 reading and content, choosing flexibly from a range of strategies.",
      subs: {
        "L.11-12.4a": "Use context (e.g., the overall meaning of a sentence, paragraph, or text; a word\u2019s position or function in a sentence) as a clue to the meaning of a word or phrase.",
        "L.11-12.4b": "Identify and correctly use patterns of word changes that indicate different meanings or parts of speech (e.g., conceive, conception, conceivable).",
        "L.11-12.4c": "Consult general and specialized reference materials (e.g., dictionaries, glossaries, thesauruses), both print and digital, to find the pronunciation of a word or determine or clarify its precise meaning, its part of speech, its etymology, or its standard usage.",
        "L.11-12.4d": "Verify the preliminary determination of the meaning of a word or phrase (e.g., by checking the inferred meaning in context or in a dictionary)."
      }
    },
    "L.11-12.5": {
      title: "Demonstrate understanding of figurative language, word relationships, and nuances in word meanings.",
      subs: {
        "L.11-12.5a": "Interpret figures of speech (e.g., hyperbole, paradox) in context and analyze their role in the text.",
        "L.11-12.5b": "Analyze nuances in the meaning of words with similar denotations."
      }
    },
    "L.11-12.6": {
      title: "Acquire and use accurately general academic and domain-specific words and phrases, sufficient for reading, writing, speaking, and listening at the college and career readiness level; demonstrate independence in gathering vocabulary knowledge when considering a word or phrase important to comprehension or expression.",
      subs: {}
    },
  },
};

/**
 * Flat lookup: all standards across all grades merged into one object.
 * Backwards compatible with code that does CCSS_ELA_STANDARDS["W.9-10.1"].
 */
export const CCSS_ELA_STANDARDS = Object.values(CCSS_ELA_BY_GRADE).reduce(
  (acc, gradeStandards) => ({ ...acc, ...gradeStandards }),
  {}
);

/** Flat list of all anchor standard codes across all grades */
export const CCSS_STANDARDS = Object.keys(CCSS_ELA_STANDARDS);

/** Grade bands available */
export const GRADE_BANDS = ["7", "8", "9-10", "11-12"];
